module.exports = __webpack_public_path__ + "static/fonts/342F4F_6_0.5f05456.woff2";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/342F4F_6_0.woff2
// module id = 112
// module chunks = 4